import { useEffect, useState } from "react";
import NotificationService from "../../services/Notification";
import ExpertDataService from "../../services/Expert";
import WorkshopDataService from "../../services/Workshop";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
export const EditNotification = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const { id } = useParams();
  const navigate = useNavigate();
  const [expertList, setExpertList] = useState<any>([]);
  const [workshops, setWorkshops] = useState<any>([]);
  const [assessments, setAssessments] = useState([
    { label: "Anxiety", value: "anxiety" },
    { label: "Mental health", value: "mentalhealth" },
    { label: "Self-esteem", value: "selfesteem" },
    { label: "Depression", value: "depression" },
    { label: "Grief and loss", value: "grief" },
    { label: "Trauma", value: "trauma" },
    { label: "Relationship", value: "relationship" },
    { label: "Workstress", value: "workstress" },
    { label: "Procrastination", value: "procrastination" },
    { label: "Anger", value: "anger" },
  ]);
  const [options, setOptions] = useState<any>([]);
  const [path, setPath] = useState("");
  const [ctaId, setCtaId] = useState("");
  const [data, setData] = useState({
    name: "",
    title: "",
    body: "",
    category: "",
    image_url: "",
    cta_label:"",
    cta_type:"",
    priority:0
  });

  const handleSubmit = () => {
    NotificationService.updateNotificationById(id, {
      ...data,
      path,
      cta_id: ctaId,
    }).then((res) => {
      navigate("/notifications");
    }).catch(e=>{
        console.log(e);
    })
  };

  const handlePathChange = (value: string) => {
    if (value === "therapy") {
      setOptions(
        expertList.map((el: any) => ({
          value: el._id,
          label: el.data.full_name,
        }))
      );
    } else if (value === "workshop") {
      setOptions(
        workshops.map((el: any) => ({
          value: el.id,
          label: el.title,
        }))
      );
    } else if (value === "assessments") {
      setOptions(assessments);
    }
    setPath(value);
  };

  const fetchExperts = () => {
    Promise.all([
      WorkshopDataService.getAllUpcomingWorkshops(token),
      ExpertDataService.getExperts(token),
      NotificationService.getNotificationById(id)
    ])
    .then(([workshopsRes, expertsRes, notificationRes]) => {
      setWorkshops(workshopsRes.data.data);
      setExpertList(expertsRes.data);
      setData(notificationRes.data);
      setCtaId(notificationRes.data.cta_id);
      setPath(notificationRes.data.path);
    })
    .catch((error) => {
      console.log(error);
    });
  };
  useEffect(() => {
    handlePathChange(path);
  }, [path]);
  
  useEffect(() => {
    fetchExperts();
  }, []);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Notifications - App Notification</div>
      <div className=" p-5">
        {/* top section */}
        <div className="row m-0 justify-content-center">
          <div className="card p-5 col-lg-10">
            {/* <form className="add_assesment_form" onSubmit={handleSubmit}> */}
            <div className="form-row">
              <div className="form-group col-md-6 mb-4">
                <label className="form-label" htmlFor="booking_date">
                  Notification Name
                </label>
                <input
                  onChange={(e) =>
                    setData({ ...data, [e.target.name]: e.target.value })
                  }
                  value={data.name}
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                />
              </div>
              <div className="form-group col-md-6 mb-4">
                <label className="form-label" htmlFor="city">
                  Notification Title
                </label>
                <input
                  type="text"
                  onChange={(e) =>
                    setData({ ...data, [e.target.name]: e.target.value })
                  }
                  value={data.title}
                  className="form-control"
                  name="title"
                />
              </div>
              <div className="form-group col-md-6 mb-4">
                <label className="form-label" htmlFor="emails">
                  Notification Body
                </label>
                <div className="input-group align-items-center">
                  <input
                    type="text"
                    className="form-control"
                    id="body"
                    value={data.body}
                    name="body"
                    onChange={(e) =>
                      setData({ ...data, [e.target.name]: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="form-group col-md-6 mb-4">
                <label className="form-label" htmlFor="emails">
                  Notification Type
                </label>
                <div className="input-group align-items-center">
                  <select
                    className="form-control"
                    name="cta_type"
                    value={data.cta_type}
                    onChange={(e) =>
                      setData({ ...data, [e.target.name]: e.target.value })
                    }
                  >
                    <option value="">Select</option>
                    <option value={"weblink"}>Web link</option>
                    <option value={"appscreen"}>App Screen</option>
                    <option value={"copy"}>Copy Text</option>
                  </select>
                </div>
              </div>

              <div className="form-group col-md-3 mb-4">
                <label className="form-label" htmlFor="emails">
                  Notification Redirect Path
                </label>
                <div className="input-group align-items-center">
                  {data.cta_type === "appscreen" ? (
                    <select
                      className="form-control"
                      name="path"
                      value={path}
                      onChange={(e) => handlePathChange(e.target.value)}
                    >
                      <option value="">Select Page</option>
                      <option value="home">Home</option>
                      <option value="selfcare">Self-care</option>
                      <option value="profile">Profile</option>
                      <option value="grounding">Grounding</option>
                      <option value="freesupport">Free support</option>
                      <option value="matchtherapist">Matched therapist</option>
                      <option value="therapy">Therapy</option>
                      <option value="workshop">Workshop</option>
                      <option value="assessments">Assessments</option>
                      <option value="emergency_contact">
                        Emergency Contact
                      </option>
                    </select>
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      name="path"
                      value={path}
                      placeholder="Enter link or copy text"
                      onChange={(e) => handlePathChange(e.target.value)}
                    />
                  )}
                </div>
              </div>
              <div className="form-group col-md-3 mb-4">
                <label className="form-label" htmlFor="emails">
                  Select Path Id
                </label>
                <div className="input-group align-items-center ">
                  <Select
                    className="col-md-12"
                    id="expert"
                    name="expert"
                    options={options}
                    placeholder="Choose Id"
                    isClearable
                    value={options.find(
                      (option: any) => option.value === ctaId
                    )}
                    onChange={(option: any) =>
                      setCtaId(option ? option.value : null)
                    }
                    isDisabled={
                      !["therapy", "workshop", "assessments"].includes(path)
                    }
                  />
                </div>
              </div>
              <div className="form-group col-md-6 mb-4">
                <label className="form-label" htmlFor="emails">
                  Notification Image
                </label>
                <div className="input-group align-items-center">
                  <input
                    type="text"
                    className="form-control"
                    id="image_url"
                    value={data.image_url}
                    name="image_url"
                    onChange={(e) =>
                      setData({ ...data, [e.target.name]: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="form-group col-md-6 mb-4">
                <label className="form-label" htmlFor="emails">
                  Select Category
                </label>
                <div className="input-group align-items-center">
                  <select
                    className="form-control"
                    name="category"
                    value={data.category}
                    onChange={(e) =>
                      setData({ ...data, [e.target.name]: e.target.value })
                    }
                  >
                    <option value="">Select Category</option>
                    <option value={"general"}>General</option>
                    <option value={"assessment"}>Assessment</option>
                    <option value={"ehc"}>EHC</option>
                    <option value={"single_session"}>Single session</option>
                    <option value={"subscription"}>Subscription</option>
                    <option value={"renew_subscription"}>
                      Renew Subscription
                    </option>
                    <option value={"special_day_offer"}>
                      Special day offer
                    </option>
                    <option value={"campaign"}>Campaign</option>
                  </select>
                </div>
              </div>

              <div className="form-group col-md-6 mb-4">
                <label className="form-label" htmlFor="emails">
                  Button Label
                </label>
                <div className="input-group align-items-center">
                  <input
                    type="text"
                    className="form-control"
                    id="cta_label"
                    value={data.cta_label}
                    name="cta_label"
                    onChange={(e) =>
                      setData({ ...data, [e.target.name]: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="form-group col-md-6 mb-4">
                <label className="form-label" htmlFor="emails">
                  Priority
                </label>
                <div className="input-group align-items-center">
                  <select
                    className="form-control"
                    value={data.priority}
                    name="priority"
                    onChange={(e) =>
                      setData({
                        ...data,
                        [e.target.name]: Number(e.target.value),
                      })
                    }
                  >
                    <option value="">Select Priority</option>
                    <option value={"0"}>0</option>
                    <option value={"1"}>1</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="text-center">
              <button
                className="btn action-btn w-25 mt-3 px-5 submit-button mx-auto"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
